import { t, STAFF_PASSWORD_MIN_LENGTH, UUID, DateTimeISO } from '../common.ts';

export const AdminStatus = t.Union(
  [t.Literal('active'), t.Literal('suspended'), t.Literal('deleted')],
  { default: 'active' },
);

export const AdminView = t.Object(
  {
    id: UUID,
    username: t.String({ minLength: 3, maxLength: 64 }),
    email: t.Union([t.String(), t.Null()]),
    roleId: UUID,
    roleName: t.Union([t.String(), t.Null()]),
    roleCode: t.Union([t.String(), t.Null()]),
    level: t.Integer({ minimum: 1, maximum: 6 }),
    twoFactorEnabled: t.Boolean(),
    status: AdminStatus,
    tenancyNodeId: t.Union([t.String(), t.Null()]),
    lastLoginAt: t.Union([DateTimeISO, t.Null()]),
    lastLoginIp: t.Union([t.String(), t.Null()]),
    createdAt: DateTimeISO,
    updatedAt: DateTimeISO,
    deletedAt: t.Union([DateTimeISO, t.Null()]),
  },
  { $id: 'AdminView' },
);

export const CreateAdminRequest = t.Object(
  {
    username: t.String({ minLength: 3, maxLength: 64 }),
    email: t.Optional(t.String({ format: 'email' })),
    password: t.String({ minLength: STAFF_PASSWORD_MIN_LENGTH, maxLength: 128 }),
    roleId: UUID,
    level: t.Integer({ minimum: 1, maximum: 6, default: 2 }),
    allowedIps: t.Optional(t.Array(t.String())),
  },
  { $id: 'CreateAdminRequest' },
);

export const UpdateAdminRequest = t.Object(
  {
    email: t.Optional(t.String({ format: 'email' })),
    roleId: t.Optional(UUID),
    level: t.Optional(t.Integer({ minimum: 1, maximum: 6 })),
    allowedIps: t.Optional(t.Array(t.String())),
  },
  { $id: 'UpdateAdminRequest' },
);

export const RoleView = t.Object(
  {
    id: UUID,
    code: t.String(),
    name: t.String(),
    description: t.Union([t.String(), t.Null()]),
    level: t.Integer({ minimum: 1, maximum: 6 }),
    isSystem: t.Boolean(),
    permissionCount: t.Integer(),
    createdAt: DateTimeISO,
  },
  { $id: 'RoleView' },
);

export const CreateRoleRequest = t.Object(
  {
    code: t.String({ minLength: 2, maxLength: 64 }),
    name: t.String({ minLength: 1, maxLength: 255 }),
    description: t.Optional(t.String({ maxLength: 500 })),
    level: t.Integer({ minimum: 1, maximum: 5 }), // L6 only via CLI
  },
  { $id: 'CreateRoleRequest' },
);

export const AssignPermissionsRequest = t.Object(
  {
    permissions: t.Array(t.String({ minLength: 3, maxLength: 128 }), { maxItems: 1000 }),
  },
  { $id: 'AssignPermissionsRequest' },
);

export const ActionLogView = t.Object(
  {
    id: UUID,
    adminId: UUID,
    resource: t.String(),
    resourceId: t.Union([t.String(), t.Null()]),
    action: t.String(),
    beforeJson: t.Union([t.Any(), t.Null()]),
    afterJson: t.Union([t.Any(), t.Null()]),
    ip: t.String(),
    userAgent: t.Union([t.String(), t.Null()]),
    severity: t.Union([t.Literal('low'), t.Literal('normal'), t.Literal('high'), t.Literal('critical')]),
    createdAt: DateTimeISO,
  },
  { $id: 'ActionLogView' },
);
